import config from '../config/catalogConfig.mjs';
import { Validator } from 'jsonschema';
const validator = new Validator();
let errors;
let context;
let contextParams;
export function setContext(value, params) {
    const contextConfig = config.contexts[value];
    errors = [];
    if (!contextConfig) {
        errors.push(`Context '${value}' is not recognised`);
    }
    else {
        const result = validator.validate(params || {}, {
            $schema: 'http://json-schema.org/draft-04/schema#',
            type: 'object',
            additionalProperties: false,
            required: Object.keys(contextConfig),
            properties: { ...contextConfig },
        });
        errors.push(...result.errors.map(String));
    }
    context = value;
    contextParams = params || {};
}
export const getContext = () => context;
export const resetContext = () => {
    context = '';
    contextParams = {};
    errors = ['No context has been set'];
};
export const getContextParams = () => Object.entries(contextParams).reduce((map, [key, value]) => ({
    ...map,
    [`context_${key}`]: value,
}), {});
export const getContextErrors = () => errors;
resetContext();
